<div class="container" *ngIf="subscription">
  <div class="container-table">
    <header class="top-header">
      <h3>Subscription Detail</h3>
    </header>

    <div class="tab-head">
      <button class="btn-action" (click)="goBack()">
        <fa-icon [icon]="['fas', 'arrow-circle-left']" class="fa-thin"></fa-icon>
        BACK
      </button>
      <div class="right-actions">
        <button class="btn-action" (click)="openUploadModal()" *ngIf="isSuperUser && activeTab === 'documents'">
          <fa-icon [icon]="['fas', 'upload']"></fa-icon>
          Upload Document
        </button>

        <button class="btn-action" *ngIf="isSuperUser" (click)="edit()">
          <fa-icon [icon]="['fas', 'pen']"></fa-icon>
          EDIT
        </button>
      </div>
    </div>

    <div class="tab-header">
      <button class="tab-button" [class.active]="activeTab === 'overview'" (click)="activeTab = 'overview'">Overview</button>
      <button class="tab-button" [class.active]="activeTab === 'items'" (click)="activeTab = 'items'">Items</button>
      <button class="tab-button" [class.active]="activeTab === 'payments'" (click)="activeTab = 'payments'">Payments</button>
      <button class="tab-button" [class.active]="activeTab === 'documents'" (click)="activeTab = 'documents'">Documents</button>
    </div>

    <div *ngIf="activeTab === 'overview'" class="tab-panel">
      <div class="overview-grid">
        <div><strong>Organization:</strong> {{ subscription.organization_name }}</div>
        <div>
          <strong>Status:</strong>
          <span class="status-pill" [class.active]="subscription.status === 'ACTIVE'"
            [class.expiring]="subscription.status === 'EXPIRING'" [class.expired]="subscription.status === 'EXPIRED'"
            [class.cancelled]="subscription.status === 'CANCELLED'">
            {{ subscription.status }}
          </span>
        </div>
        <div><strong>Billing Type:</strong> {{ subscription.billing_type }}</div>
        <div><strong>No. of Cameras:</strong> {{ getCameraCount() }}</div>
        <div><strong>Start Date:</strong> {{ subscription.start_date | date: 'dd/MM/yyyy' }}</div>
        <div><strong>Next Payment Due Date:</strong> {{ subscription.next_payment_due_date ? (subscription.next_payment_due_date | date: 'dd/MM/yyyy') : '-' }}</div>
        <div><strong>Contract End Date:</strong> {{ subscription.expiry_date | date: 'dd/MM/yyyy' }}</div>
        <div><strong>Duration:</strong> {{ subscription.contract_duration_years }} years</div>
        <div><strong>Contract Value:</strong> {{ subscription.currency }} {{ subscription.total_amount }}</div>
        <div><strong>Total Paid:</strong> {{ subscription.currency }} {{ subscription.total_paid_amount || '0.00' }}</div>
        <div><strong>Pending:</strong> {{ subscription.currency }} {{ subscription.pending_amount || '0.00' }}</div>
      </div>

      <div class="contact-sections">
        <div class="contact-card">
          <h4>Customer POC</h4>
          <div><strong>Name:</strong> {{ subscription.customer_poc_name || '-' }}</div>
          <div><strong>Email:</strong> {{ subscription.customer_poc_email || '-' }}</div>
          <div><strong>Phone:</strong> {{ subscription.customer_poc_phone || '-' }}</div>
        </div>
        <div class="contact-card">
          <h4>Kyra Sales POC</h4>
          <div><strong>Name:</strong> {{ subscription.kyra_sales_poc_name || '-' }}</div>
          <div><strong>Email:</strong> {{ subscription.kyra_sales_poc_email || '-' }}</div>
          <div><strong>Phone:</strong> {{ subscription.kyra_sales_poc_phone || '-' }}</div>
        </div>
      </div>

      <div class="history-grid">
        <div class="history-card">
          <h4>Last Expiry Alert Sent</h4>
          <div><strong>On:</strong> {{ subscription.last_expiry_alert_sent_at ? (subscription.last_expiry_alert_sent_at | date: 'dd/MM/yyyy, h:mm a') : '-' }}</div>
          <div><strong>By:</strong> {{ subscription.last_expiry_alert_sent_by_name || '-' }}</div>
          <div><strong>To:</strong> {{ getLastSentTo(subscription.last_expiry_alert_sent_to) }}</div>
        </div>
        <div class="history-card">
          <h4>Last Payment Reminder Sent</h4>
          <div><strong>On:</strong> {{ subscription.last_payment_reminder_sent_at ? (subscription.last_payment_reminder_sent_at | date: 'dd/MM/yyyy, h:mm a') : '-' }}</div>
          <div><strong>By:</strong> {{ subscription.last_payment_reminder_sent_by_name || '-' }}</div>
          <div><strong>To:</strong> {{ getLastSentTo(subscription.last_payment_reminder_sent_to) }}</div>
        </div>
      </div>

      <div class="alert-actions">
        <button *ngIf="isSuperUser" class="btn-action" (click)="sendExpiryAlert()">
          <fa-icon [icon]="['fas', 'paper-plane']" class="fa-solid"></fa-icon>
          Send Expiry Alert
        </button>
        <button *ngIf="isSuperUser" class="btn-action" (click)="sendPaymentReminder()">
          <fa-icon [icon]="['fas', 'paper-plane']" class="fa-solid"></fa-icon>
          Send Payment Reminder
        </button>
      </div>
    </div>

    <div *ngIf="activeTab === 'items'" class="tab-panel responsive-table-wrapper">
      <table>
        <thead>
          <tr>
            <th>Name</th>
            <th>HSN/SAC</th>
            <th>Qty</th>
            <th>Unit Price</th>
            <th>Tax</th>
            <th>Recurring</th>
            <th>One Time</th>
            <th>Year</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let item of subscription.items">
            <td>{{ item.name }}</td>
            <td>{{ item.hsn_sac || '-' }}</td>
            <td>{{ item.quantity }}</td>
            <td>{{ item.unit_price }}</td>
            <td>{{ item.tax }}</td>
            <td>{{ item.is_recurring ? 'Yes' : 'No' }}</td>
            <td>{{ item.is_one_time ? 'Yes' : 'No' }}</td>
            <td>{{ item.year_applicable || '-' }}</td>
          </tr>
          <tr *ngIf="!subscription.items || subscription.items.length === 0">
            <td colspan="8">No items.</td>
          </tr>
        </tbody>
      </table>
    </div>

    <div *ngIf="activeTab === 'payments'" class="tab-panel">
      <div class="responsive-table-wrapper">
        <table class="detail-table">
          <thead>
            <tr>
              <th>Year</th>
              <th>Amount</th>
              <th>Due Date</th>
              <th>Paid</th>
              <th>Paid On</th>
              <th *ngIf="isSuperUser">Action</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let pay of payments">
              <td>{{ pay.year }}</td>
              <td>{{ pay.amount }}</td>
              <td>{{ pay.due_date | date: 'dd/MM/yyyy' }}</td>
              <td>
                <ng-container *ngIf="isSuperUser; else paidReadonly">
                  <select [(ngModel)]="pay.is_paid" [ngModelOptions]="{ standalone: true }">
                    <option [ngValue]="true">Yes</option>
                    <option [ngValue]="false">No</option>
                  </select>
                </ng-container>
                <ng-template #paidReadonly>{{ pay.is_paid ? 'Yes' : 'No' }}</ng-template>
              </td>
              <td>
                <ng-container *ngIf="isSuperUser; else paidOnReadonly">
                  <input
                    type="date"
                    [(ngModel)]="pay.paid_on"
                    [ngModelOptions]="{ standalone: true }"
                    [disabled]="!pay.is_paid" />
                </ng-container>
                <ng-template #paidOnReadonly>
                  {{ pay.paid_on ? (pay.paid_on | date: 'dd/MM/yyyy') : '-' }}
                </ng-template>
              </td>
              <td *ngIf="isSuperUser">
                <button class="btn-action btn-inline" type="button" (click)="updatePaymentStatus(pay)" [disabled]="pay.saving">
                  {{ pay.saving ? 'Saving...' : 'Update' }}
                </button>
              </td>
            </tr>
            <tr *ngIf="payments.length === 0">
              <td [attr.colspan]="isSuperUser ? 6 : 5">No payments.</td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="payment-form" *ngIf="isSuperUser">
        <form #paymentForm="ngForm" novalidate>
          <h4>Add Payment</h4>
          <div class="payment-grid">
            <div class="field">
              <input type="number" min="1" name="year" required [(ngModel)]="newPayment.year" #year="ngModel" placeholder="Year" />
              <span class="error" *ngIf="year.invalid && (year.dirty || year.touched)">Year is required.</span>
            </div>
            <div class="field">
              <input type="number" min="0" name="amount" required [(ngModel)]="newPayment.amount" #amount="ngModel" placeholder="Amount" />
              <span class="error" *ngIf="amount.invalid && (amount.dirty || amount.touched)">Amount is required.</span>
            </div>
            <div class="field">
              <input type="date" name="due_date" required [(ngModel)]="newPayment.due_date" #dueDate="ngModel" />
              <span class="error" *ngIf="dueDate.invalid && (dueDate.dirty || dueDate.touched)">Due date is required.</span>
            </div>
            <label class="checkbox">
              <input type="checkbox" name="is_paid" [(ngModel)]="newPayment.is_paid" />
              Paid
            </label>
            <div class="field">
              <input type="date" name="paid_on" [(ngModel)]="newPayment.paid_on" [disabled]="!newPayment.is_paid" />
            </div>
          </div>
          <span class="error" *ngIf="paymentError">{{ paymentError }}</span>
          <button class="btn-action" type="button" (click)="savePayment()" [disabled]="paymentForm.invalid">Save Payment</button>
        </form>
      </div>
    </div>

    <div *ngIf="activeTab === 'documents'" class="tab-panel">
      <div class="responsive-table-wrapper">
        <table class="detail-table">
          <thead>
            <tr>
              <th>Type</th>
              <th>File</th>
              <th>Uploaded By</th>
              <th>Email</th>
              <th>Uploaded At</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let doc of documents">
              <td>{{ doc.doc_type }}</td>
              <td>
                <a [href]="getDocumentUrl(doc)" target="_blank" rel="noopener noreferrer" [attr.download]="getDocumentName(doc)">
                  {{ getDocumentName(doc) }}
                </a>
              </td>
              <td>{{ doc.uploaded_by_full_name || '-' }}</td>
              <td>{{ doc.uploaded_by_email || '-' }}</td>
              <td>{{ doc.created_at ? (doc.created_at | date: 'dd/MM/yyyy, h:mm a') : '-' }}</td>
            </tr>
            <tr *ngIf="documents.length === 0">
              <td colspan="5">No documents.</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</div>

<div *ngIf="showUploadModal" class="confirmation-modal">
  <div class="modal-content upload-modal-content">
    <div class="modal-header upload-modal-header">
      <h3>Upload Document</h3>
      <p>Upload a PDF document to process</p>
    </div>
    <div class="modal-body">
      <div>
        <select class="type-dropdown" [(ngModel)]="docType">
          <option value="PO">Purchase Order</option>
          <option value="QUOTE">Quotation</option>
          <option value="PI">Proforma Invoice</option>
        </select>
      </div>
      <div class="drop-zone" [class.drag-over]="isDragOver" (dragover)="onDragOver($event)"
        (dragleave)="onDragLeave()" (drop)="onDrop($event)" (click)="docFileInput.click()">
        <input #docFileInput id="quotationFile" type="file" (change)="onDocSelected($event)" accept="application/pdf" style="display:none" />
        <div class="drop-zone-icon">
          <svg xmlns="http://www.w3.org/2000/svg" width="56" height="56" viewBox="0 0 24 24" fill="none"
            stroke="#374151" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
            <path d="M4 14.899A7 7 0 1 1 15.71 8h1.79a4.5 4.5 0 0 1 2.5 8.242" />
            <path d="M12 12v9" />
            <path d="m16 16-4-4-4 4" />
          </svg>
        </div>
        <p class="drop-zone-text">Drag and drop your file here</p>
        <p class="drop-zone-or">— OR —</p>
        <button class="browse-btn" type="button" (click)="$event.stopPropagation(); docFileInput.click()">Browse files</button>
      </div>
      <div *ngIf="docFile" class="selected-file-info">
        <i class="bi bi-file-earmark-pdf-fill"></i>
        <span>{{ selectedDocName }}</span>
        <button class="remove-file-btn" type="button" (click)="clearSelectedFile()" title="Remove file">✕</button>
      </div>
      <div class="error" *ngIf="docError" style="padding: 0 4px;">
        <small>{{ docError }}</small>
      </div>
    </div>
    <div class="button-row">
      <button class="btn-cancel" (click)="closeUploadModal()">
        <fa-icon [icon]="['fas', 'square-xmark']" style="padding-right: 3px;"></fa-icon>
        Cancel
      </button>
      <button (click)="uploadDocument()" class="btn-save" [disabled]="!docFile">
        <fa-icon [icon]="['fas', 'file-upload']" style="padding-right: 3px;"></fa-icon>
        Upload
      </button>
    </div>
  </div>
</div>

<div *ngIf="reminderConfirmVisible" class="confirmation-modal">
  <div class="modal-content">
    <div class="modal-header">
      <h3>Send Again?</h3>
    </div>
    <div class="modal-body">
      <p>{{ reminderConfirmMessage }}</p>
    </div>
    <div class="modal-footer">
      <button (click)="confirmReminderResend()" class="confirm-btn modal-red">Send Again</button>
      <button (click)="cancelReminderConfirm()" class="cancel-btn cancel-btn-green">Cancel</button>
    </div>
  </div>
</div>
